<template>
  <div class="">
    <PreLoader v-if="isLoading" />
    <ExceptionWithImg v-if="exceptionMsg" :msg="exceptionMsg" />

    <ActivityForm
      v-if="!isLoading"
      :activityData="activityData"
      :imageSrc="imageSrc"
      :submitName="$t('edit')"
      v-on:addOrUpdateActivity="updateActivity"
    />
  </div>
</template>

<script>
import PreLoader from "@/components/general/PreLoader.vue";
import ExceptionWithImg from "@/components/general/ExceptionWithImg.vue";
import { STATUS, BASE_URL } from "@/utils/constants";
import DEFAULT_IMG from "@/assets/images/type.svg";
// import { date2slash, date2dash, timeTo12, timeTo24 } from "@/utils/functions";
import ActivityForm from "@/components/settings/settingsOther/activities/ActivityForm.vue";
import Activity from "@/models/settings/settingsOther/activities/Activity";
import createToastMixin from "@/utils/create-toast-mixin";

export default {
  name: "ActivityEdit",
  mixins: [createToastMixin],
  components: {
    PreLoader,
    ExceptionWithImg,
    ActivityForm,
  },
  data() {
    return {
      isLoading: true,
      exceptionMsg: null,
      exceptionImg: null,
      language: localStorage.getItem("userLanguage") || "ar",
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken ||
        null,
      imageSrc: DEFAULT_IMG,
      activityData: new Activity(),
      activityToken: this.$route.params.activityToken,
    };
  },
  methods: {
    async getActivityDetails() {
      this.isLoading = true;
      this.activityData.activityToken = this.activityToken;
      try {
        let response = await this.activityData.getActivityDetails(
          this.language,
          this.userAuthorizeToken
        );
        if (response.data.status == STATUS.SUCCESS) {
          this.activityData.fillData(response.data.activityData);

          this.activityData.image = "";
          if (this.activityData.activityImagePath) {
            this.imageSrc = BASE_URL + this.activityData.activityImagePath;
          }
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.showMsg(response.data.msg);
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.showMsg(response.data.msg);
          this.activityData = null;
        }
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
        this.activityData = null;
      }
      this.isLoading = false;
    },
    async updateActivity() {
      this.isLoading = true;
      try {
        let response = await this.activityData.addOrUpdateActivity(
          this.language,
          this.userAuthorizeToken
        );
        if (response.data.status == STATUS.SUCCESS) {
          this.showMsg(response.data.msg, true);
          this.$router.push({ name: "Activities" });
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.showMsg(response.data.msg);
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.showMsg(response.data.msg);
        }
      } catch (e) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
  },
  async created() {
    this.getActivityDetails();
  },
};
</script>

<style scoped lang="scss"></style>
